/* Keep sticky product information and anchor targets clear of the announcement. */
if (!customElements.get('mommily-announcement-offset')) {
  customElements.define('mommily-announcement-offset', class extends HTMLElement {
    connectedCallback() {
      this.bar = this.closest('.announcement-bar-section');
      if (!this.bar || this.observer) return;
      this.measure = () => document.documentElement.style.setProperty('--mt-announcement-height', `${this.bar.getBoundingClientRect().height}px`);
      this.measure();
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.bar);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      document.documentElement.style.removeProperty('--mt-announcement-height');
    }
  });
}
